<script>
import EzButton from '@/components/ui/Button/EzButton';

/**
 *
 * @version 1.0.0
 * @since
 */
export default {
  components: {
    EzButton,
  },
  props: {
    disabled: {
      required: false,
      type: Boolean,
    },
    type: {
      required: false,
      type: String,
      default: 'primary',
    },
  },
  computed: {
    isPrimary() {
      return this.type === 'primary';
    },
  },
};
</script>
<template>
  <ez-button
    class="dropdown-actions__btn dropdown-actions__btn--decline"
    :type="type"
    :disabled="disabled"
    @click="$emit('actionClicked')">
    {{ isPrimary ? 'Decline Entire Order' : 'Decline Entire Order' }}
  </ez-button>
</template>
<style lang="scss" scoped></style>
